import { VideoCard } from '@components/Card';
import { FlexView, Text } from '@components/Common';
import languags from '@locales/languages';
import { Colors } from '@styles/system';
import { useResponsive } from '@utils/hooks';
import { useState, useRef, useEffect } from 'react';

interface SectionProps {
  lang: 'ko' | 'en';
}

export default ({ lang }: SectionProps) => {
  const deviceType = useResponsive();
  const texts = languags[lang].howToUse;
  const wrapperRef = useRef<HTMLDivElement>(null);

  const [cardInfo, setCardInfo] = useState([
    {
      title: texts.title1,
      content: deviceType === `M` ? texts.content1M : texts.content1,
      video: ``,
    },
    {
      title: texts.title2,
      content: deviceType === `M` ? texts.content2M : texts.content2,
      video: ``,
    },
    {
      title: texts.title3,
      content: deviceType === `M` ? texts.content3M : texts.content3,
      video: ``,
    },
  ]);

  useEffect(() => {
    const options = {
      root: document.getElementById(`about`),
      rootMargin: `0px`,
      threshold: 0.8,
    };

    let observer: IntersectionObserver;
    const getVideoSrc: IntersectionObserverCallback = ([isIntersecting]) => {
      if (isIntersecting) {
        cardInfo[0].video = `https://video.block-chat.net/videos/${lang}/howtouse01.mp4`;
        cardInfo[1].video = `https://video.block-chat.net/videos/${lang}/howtouse02.mp4`;
        cardInfo[2].video = `https://video.block-chat.net/videos/${lang}/howtouse03.mp4`;
        setCardInfo([...cardInfo]);

        observer.unobserve(wrapperRef.current as Element);
      }
    };

    observer = new IntersectionObserver(getVideoSrc, options);
    observer.observe(wrapperRef.current as Element);

    return () => {
      observer.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FlexView
      ref={wrapperRef}
      css={{
        padding: deviceType !== `M` ? `100px 24px` : `60px 24px`,
        minHeight: `${window.innerHeight}px`,
      }}
      id="howtouse"
    >
      <FlexView
        css={{
          maxWidth: `1400px`,
          width: `100%`,
          margin: `0 auto`,
          overflowX: `hidden`,
        }}
      >
        <Text
          color={Colors.white}
          css={{
            fontSize: deviceType === `M` ? `40px` : `64px`,
            lineHeight: 1,
          }}
          bold
          center
        >
          {texts.title}
        </Text>

        <Text
          color={Colors.secondary70}
          css={{ margin: `24px 0 60px 0` }}
          large={deviceType !== `M`}
          center
          multiLine
        >
          {deviceType === `P` ? texts.describe : texts.describeM}
        </Text>

        <FlexView
          css={{
            overflowX: `auto`,
            whiteSpace: `nowrap`,
            scrollbarHeight: `none`,
            '::-webkit-scrollbar': { display: `none` },
          }}
        >
          <FlexView css={{ margin: `0 auto` }} gap={24} row>
            {cardInfo?.map((item, index) => (
              <VideoCard
                key={item.title}
                content={item.content}
                selected={index === 0}
                title={item.title}
                video={item.video}
              />
            ))}
          </FlexView>
        </FlexView>
      </FlexView>
    </FlexView>
  );
};
